module.exports = __webpack_public_path__ + "fce88f057a8d7353678072b9cd189c68.svg";